import * as React from "react";
import Helmet from "react-helmet";
import { RouteComponentProps } from "react-router";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";

// global
import { Wrap } from "../../../components/Layout/Page";
import {
  updateDaysRange,
  updateIsMultiSiteRoute,
} from "../../../redux/modules/_BETA/selections";

// hooks and state
import { updateInsightsUrlHistory } from "../../../redux/modules/urlHistory/actionCreators";
import { useActions as useAnalysisActions } from "../../../context/analysis";
import { useActions as useInsightsActions } from "../../../context/insights/useActions";

// component
import { Insights } from "../../../components/Analysis/Insights";
import { SubNav } from "../../../components/Analysis/SubNav";
import { Category } from "../../../components/Analysis/utils/types";
import { useInsightsEffects } from "../hooks/useInsightsEffects";
import { useInsights } from "../../../context/insights";

function mapStateToProps(state: Insite.AppState) {
  return {
    appReady: state.appSetup.appSetupComplete,
    timeRange: state.betaSelections.daysRange,
    hasPermission:
      state.auth.user.access &&
      state.auth.user.access.includes("viewTriagePage"),
    selectedSites: state.betaSelections.selectedSites,
    shouldRequestInsights: state.requestSchedule.shouldRequestInsights,
    sites: state.userSites.sites,
    projects: state.userSites.projects,
    showSnoozed: state.insights.showSnoozed,
  };
}

const mapDispatchToProps = {
  updateDaysRange,
  updateInsightsUrlHistory,
  setMultiSite: updateIsMultiSiteRoute,
};

type FCProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  RouteComponentProps;

const InsightsSceneFC: React.FC<FCProps> = ({
  appReady,
  hasPermission,
  timeRange,
  selectedSites,
  sites,
  projects,
  updateDaysRange,
  shouldRequestInsights,
  setMultiSite,
  history,
  showSnoozed,
}) => {
  if (!appReady) return null;
  if (!hasPermission) return <Redirect to="/actions" />;

  const { setCategory } = useInsightsActions();
  const { setViewMode } = useAnalysisActions();

  const [state] = useInsights();
  useInsightsEffects(
    timeRange,
    selectedSites,
    shouldRequestInsights,
    sites,
    projects
  );

  React.useEffect(() => {
    setViewMode("insights");
  });

  React.useEffect(() => {
    setMultiSite(selectedSites.length > 1);
  }, [selectedSites]);

  const onChangeCategory = React.useCallback((category: Category) => {
    setCategory(history, category);
  }, []);

  return (
    <>
      <Helmet title="Insights" />
      <SubNav category={state.category} onChangeCategory={onChangeCategory} />
      <Wrap>
        <Insights
          history={history}
          updateHistory={updateInsightsUrlHistory}
          updateTimeRange={updateDaysRange}
          timeRange={timeRange}
          showSnoozed={showSnoozed}
        />
      </Wrap>
    </>
  );
};

export const InsightsScene = connect(
  mapStateToProps,
  mapDispatchToProps
)(InsightsSceneFC);
